webpackJsonp([98334752301208],{

/***/ 1080:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"GithubButton","methods":[{"name":"onChange","docblock":null,"modifiers":[],"params":[{"name":"prevProps","type":null}],"returns":null},{"name":"getRepositoryStats","docblock":null,"modifiers":[],"params":[{"name":"username","type":null},{"name":"repository","type":null},{"name":"btnType","type":null}],"returns":null},{"name":"getUserFallowers","docblock":null,"modifiers":[],"params":[{"name":"username","type":null}],"returns":null},{"name":"openUrl","docblock":null,"modifiers":[],"params":[],"returns":null}],"props":{"showCounter":{"type":{"name":"bool"},"required":false,"description":"Shows the total next to the button.","defaultValue":{"value":"true","computed":false}},"showBtnText":{"type":{"name":"bool"},"required":false,"description":"Shows the text inside the button.","defaultValue":{"value":"true","computed":false}},"showGithubIcon":{"type":{"name":"bool"},"required":false,"description":"Shows github icon on the button.","defaultValue":{"value":"false","computed":false}},"disabled":{"type":{"name":"bool"},"required":false,"description":"Shows github button disabled.","defaultValue":{"value":"false","computed":false}},"loadingClass":{"type":{"name":"string"},"required":false,"description":"Class to loading indicator.","defaultValue":{"value":"'fa fa-circle-o-notch fa-spin'","computed":false}},"username":{"type":{"name":"string"},"required":false,"description":"Github username.","defaultValue":{"value":"'front10'","computed":false}},"repository":{"type":{"name":"string"},"required":false,"description":"Github repository.","defaultValue":{"value":"'landing-page-book'","computed":false}},"type":{"type":{"name":"string"},"required":false,"description":"What button show. Can be: <code>fork</code>,<code>follow</code>,<code>star</code>,<code>download</code>,<code>watch</code>,<code>issue</code>`","defaultValue":{"value":"'fork'","computed":false}},"text":{"type":{"name":"string"},"required":false,"description":"text to show inside the button","defaultValue":{"value":"'Fork'","computed":false}},"color":{"type":{"name":"string"},"required":false,"description":"Color of button.","defaultValue":{"value":"'light'","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"CSS class name selector to customs styles","defaultValue":{"value":"''","computed":false}}},"filename":"/components/GithubButton/GithubButton.jsx"}

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _githubbutton = __webpack_require__(510);
	
	var _githubbutton2 = _interopRequireDefault(_githubbutton);
	
	var _map = __webpack_require__(1080);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _githubbutton2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _githubbutton2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/GithubButton',
	        description: _githubbutton2.default.summary,
	        stories: _githubbutton2.default.stories,
	        importCode: _githubbutton2.default.import,
	        withStyles: _githubbutton2.default.withStyles,
	        extractProps: _githubbutton2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'GithubButton',
	  summary: 'Showcase the success of any GitHub repo or user with these simple, static buttons with dynamic counts.',
	  import: '',
	  extractProps: ['button', 'counter'],
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<GithubButton\n    username="front10"\n    repository="landing-page-book"\n    color="secondary"\n/>',
	    tabsActive: ['code']
	  }, {
	    name: 'All',
	    summary: '',
	    code: '<>\n    <div className="mb-3">\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="fork" text="Fork" color="secondary" />\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="follow" text="Follow" color="secondary" />\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="star" text="Stars" color="secondary"/>\n    </div>\n    <div>\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="watch" text="Watch" color="secondary" />\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="issue" text="Issues" color="secondary" />\n        <GithubButton className="mr-3" username="front10" repository="landing-page-book" type="download" text="Download" showCounter={false} color="secondary" />\n    </div>\n</>',
	    tabsActive: []
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-githubbutton-js-afbaba66f293b6afaf08.js